import Grid from "@mui/material/Grid";
import MssIcon from "../../common/MssIcon";

const InAndOutHelp = () => {
  return (
    <>
      <Grid container flexDirection={"column"} alignItems="center">
        <span className="title" style={{ textAlign: "center", marginTop: "84px" }}>
          등록이 완료되었습니다 <br />
          이제 피플카운트 시스템을 사용해볼까요?
        </span>
        <span style={{ marginTop: "13px" }}>
          문열림 센서를 이용해 실내 공간의 입출입 유동인구를 분석할 수 있습니다.
        </span>
      </Grid>

      <Grid container display={"flex"} marginTop={"67px"}>
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid container alignItems={"center"} justifyContent="center">
            <Grid item md={3}>
              <MssIcon name="17-help" className="sensor-model" />
            </Grid>
            <Grid item md={6} display={"flex"} flexDirection={"column"} sx={{ color: "#7D88B0" }}>
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>[올바른 센서 설치 안내]</span>
              <ul style={{ marginTop: "13px" }}>
                <li>스마트 허브 후면의 등록버튼을 눌러 센서 등록 준비를 해주세요.</li>
                <li>
                  열림감지기의 배터리 결합 시, 그림처럼 한 방향의 상부에 힘을 주어 센서를 열고 전원을 연결해주세요.
                </li>
                <li>
                  <b>10</b>초 이내에 스마트 허브에서 ‘삐리리’ 소리가 나면 등록이 완료됩니다.
                </li>
              </ul>
              <span style={{ marginTop: "13px" }}> ※ 사람 손이 잘 닿이지 않는 문 위쪽에 설치하는걸추천드립니다!</span>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InAndOutHelp;
